import {CURRENCIES} from '../constants/order';

export enum FxTab {
    NO_LIMIT = 'no_limit',
    ONLY_LIMIT = 'only_limit',
    HISTORY = 'history',
}
export type CurrencyType = typeof CURRENCIES[number];

export interface IDealRequest {
    '@context': string;
    '@id': string;
    '@type': 'DealRequest';
    amountFrom: string;
    amountTo: string;
    businessPartner: string;
    createdAt: string;
    currencyFrom: string;
    currencyTo: string;
    dealType: string;
    discountFactor: string;
    forwardPips: string;
    forwardPoints: string;
    midRate: string;
    platformRate: string;
    savedAmount: string;
    spotRate: string;
    status: string;
    type: string;
    user: string;
    uuid: string;
    valueDate: string;
    volumeCHF: string;
}

export type ActiveDeal = {
    '@id': string;
    id: string;
    dealType: string;
    amountFrom: string;
    amountTo: string;
    currencyFrom: string;
    currencyTo: string;
    exchangeRate: string;
    platformRate: string;
    midRate: string;
    valueDate: string;
    saved: string;
    spotRate: string;
    forwardPips: string;
};

export type SwapDealType = {
    '@id': string;
    '@type': string;
    amountFrom: string;
    amountTo: string;
    businessPartner: string;
    createdAt: string;
    currencyFrom: string;
    currencyTo: string;
    dealType: string;
    discountFactor: string;
    fee: number;
    forwardPips: string;
    forwardPoints: string;
    midRate: string;
    platformRate: string;
    savedAmount: string;
    spotRate: string;
    status: string;
    type: string;
    usedRate: string;
    user: string;
    uuid: string;
    valueDate: string;
    volumeCHF: string;
    xigniteMidRate: string;
};

export type SplitDealFieldsType = {
    amountFrom: string;
    amountTo: string;
    valueDate: string;
};

export type ActiveSwapDeal = {
    '@id': string;
    id: string;
    farDealRequest: SwapDealType;
    nearDealRequest: SwapDealType;
};

export type CreateLimitOrder = {
    from_limit: CurrencyType;
    to_limit: CurrencyType;
    amount_limit: string;
    limit_rate: string;
};

export type LimitOrderConfirmation = CreateLimitOrder & {
    '@id': string;
    createdAt: string;
    expireOn: string;
    id: number;
    status: string;
    type: string;
    dealRequest: {
        '@id': string;
        amountFrom: string;
        amountTo: string;
        currencyFrom: string;
        currencyTo: string;
        dealType: string;
        platformRate: string;
        points: number;
        savedAmount: string;
        spotRate: string;
        status: string;
        usedRate: string;
        valueDate: string;
        xigniteMidRate: string;
        businessPartner: unknown;
    };
};
